import { render } from "./BillingComponent.vue?vue&type=template&id=4f9893b8"
import script from "./BillingComponent.vue?vue&type=script&lang=js"
export * from "./BillingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__